export default __webpack_public_path__ + "b9136d493fa7c3444b8a982fc9ba4095.png";